import { combineReducers } from "redux";
import { handleActions } from "redux-actions";

import {
    questionCurrentSet,
    questionInsert,
    questionSetAnswer,
    questionSetFilter,
    questionsReset,
} from "./actions";

export default combineReducers({
    current: handleActions(
        {
            [questionCurrentSet]: (state, { payload }) => payload,
            [questionsReset]: () => 0,
        },
        0,
    ),
    filters: handleActions(
        {
            [questionSetFilter]: (state, { payload: { filter, value } }) => ({
                ...state,
                [filter]: value,
            }),
        },
        {
            roleType: null,
            preferences: true,
        },
    ),
    questions: handleActions(
        {
            [questionSetAnswer]: (state, { payload: { questionID, response } }) =>
                state.slice().map((q) => {
                    if (q.id !== questionID) {
                        return q;
                    }

                    return {
                        ...q,
                        response,
                    };
                }),

            [questionInsert]: (state, { payload: { questions, index } }) => {
                const newState = state.slice(0, index + 1);
                const existing = newState.map((q) => q.id);
                const next = questions.filter((q) => !existing.includes(q.id));
                return [...newState, ...next];
            },

            [questionsReset]: (state) =>
                state.map((q) => ({
                    ...q,
                    response: null,
                })),
        },
        [],
    ),
});
